/*
 * Copyright Huesik (c) 2019.
 */

const filterConstant = {
  USE_SEX_TYPE: {
    SEPARATE: 'S',
    UNIVERSAL: 'U',
    WOMAN: 'W',
    MAN: 'M'
  },

  DEFAULT_FILTERS: {
    MONEY_RANGE: [0, 120],
    USE_SEX_TYPE: [],
    OPTIONAL_FILTER: {
      is_elevator: 0,
      is_parking : 0,
      is_cctv : 0,
      option_doorlock : 0,
      option_refrigerator : 0,
      option_tv : 0,
      option_internet : 0,
      option_aircon : 0,
      option_wash : 0,
      is_dry : 0,
      is_sprinkler: 0,
      is_double_room: 0
    },
    ROOM_TYPE: []
  },
}

export default filterConstant
